/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface GetWarsWarIdUnprocessableEntity
 */
export interface GetWarsWarIdUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof GetWarsWarIdUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the GetWarsWarIdUnprocessableEntity interface.
 */
export function instanceOfGetWarsWarIdUnprocessableEntity(value: object): value is GetWarsWarIdUnprocessableEntity {
    return true;
}

export function GetWarsWarIdUnprocessableEntityFromJSON(json: any): GetWarsWarIdUnprocessableEntity {
    return GetWarsWarIdUnprocessableEntityFromJSONTyped(json, false);
}

export function GetWarsWarIdUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWarsWarIdUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetWarsWarIdUnprocessableEntityToJSON(json: any): GetWarsWarIdUnprocessableEntity {
    return GetWarsWarIdUnprocessableEntityToJSONTyped(json, false);
}

export function GetWarsWarIdUnprocessableEntityToJSONTyped(value?: GetWarsWarIdUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

